(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elali-closet-popup"] && !Shopify.designMode) return;
  try {
    (() => {
const popup=document.getElementById('ElaliInsiderPopup');
if(!popup || !popup.showModal)return;
const read=key=>{try{return localStorage.getItem(key)}catch{return null}};
const write=(key,value)=>{try{localStorage.setItem(key,value)}catch{}};
const success=popup.querySelector('[data-insider-success]');
const errors=popup.querySelector('[data-insider-errors]');
if(!success&&!errors&&(read('elaliInsiderSubscribed')||Date.now()-Number(read('elaliInsiderDismissedAt')||0)<7*86400000))return;
if(success)write('elaliInsiderSubscribed','1');
let overflow,focus;
const open=()=>{
if(!window.elaliLanguageResolved || document.querySelector('dialog[open]'))return;
focus=document.activeElement;overflow=document.body.style.overflow;
popup.showModal();document.body.style.overflow='hidden';
if(success)success.focus();
};
popup.querySelectorAll('[data-insider-close]').forEach(button=>button.addEventListener('click',()=>popup.close()));
popup.addEventListener('close',()=>{write('elaliInsiderDismissedAt',String(Date.now()));document.body.style.overflow=overflow||'';if(focus&&focus.isConnected)focus.focus()});
let chosenAt=0;
try{chosenAt=Number(sessionStorage.getItem('elaliLanguageChosenAt')||0)}catch{}
const delay=success||errors?0:Math.max(1000,8000-(Date.now()-chosenAt));
document.addEventListener('elali:language-resolved',()=>setTimeout(open,8000),{once:true});
setTimeout(open,delay);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elali-language-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const popup = document.getElementById('ElaliLanguagePopup');
  const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, value); } catch {} };
  const storage = (() => { try { return window.localStorage; } catch { return null; } })();
  const session = (() => { try { return window.sessionStorage; } catch { return null; } })();
  const resolve = () => {
    window.elaliLanguageResolved = true;
    document.dispatchEvent(new Event('elali:language-resolved'));
  };
  if (!popup || !popup.showModal || read(storage, 'elaliPreferredLanguage') || read(session, 'elaliLanguageDismissed')) {
    resolve();
    return;
  }
  if (window.Shopify && window.Shopify.designMode) { resolve(); return; }
  let priorFocus;
  let priorOverflow;
  popup.querySelector('form').addEventListener('submit', event => {
    const choice = event.submitter;
    if (!choice || !['en', 'ar'].includes(choice.value)) return;
    write(storage, 'elaliPreferredLanguage', choice.value);
    write(session, 'elaliLanguageChosenAt', String(Date.now()));
    // Native form submission preserves Shopify locale and the current page.
  });
  popup.querySelector('[data-language-close]').addEventListener('click', () => popup.close());
  popup.addEventListener('close', () => {
    write(session, 'elaliLanguageDismissed', '1');
    write(session, 'elaliLanguageChosenAt', String(Date.now()));
    document.body.style.overflow = priorOverflow || '';
    if (priorFocus && priorFocus.isConnected) priorFocus.focus();
    resolve();
  });
  setTimeout(() => {
    if (document.querySelector('dialog[open]')) { resolve(); return; }
    priorFocus = document.activeElement;
    priorOverflow = document.body.style.overflow;
    popup.showModal();
    document.body.style.overflow = 'hidden';
  }, 250);
})();
  } catch(e) { console.error(e); }
})();

})();
